import React from "react";

const Avatar = ({ src, name, size = 8 }) => {
  const getInitials = (name) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const sizeClasses = {
    6: "w-6 h-6 text-xs",
    8: "w-8 h-8 text-sm",
    10: "w-10 h-10 text-sm",
    12: "w-12 h-12 text-base",
  };

  const sizeClass = sizeClasses[size] || sizeClasses[8];

  return (
    <div className={`relative ${sizeClass}`}>
      {src ? (
        <img
          src={src}
          alt={name}
          className={`object-cover rounded-full border-2 border-white shadow-sm ${sizeClass}`}
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
      ) : null}
      <div
        className={`${
          src ? "hidden" : "flex"
        } justify-center items-center ${sizeClass} font-medium text-white bg-gradient-to-br from-pink-500 to-pink-600 rounded-full`}
      >
        {getInitials(name)}
      </div>
    </div>
  );
};

export default Avatar;
